import ScrollReveal from "../components/ScrollReveal";
import Pricing from "../components/sections/Pricing";
import CTASection from "../components/sections/CTASection";

export default function PricingPage() {
  return (
    <div data-testid="pricing-page">
      <section className="pt-36 md:pt-44 pb-16 md:pb-24 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / Pricing
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.95]">
              Sharp prices.<br /><span className="text-white/40">Sharper work.</span>
            </h1>
            <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
              Starting prices in ₹ INR. Every engagement is custom-scoped on a
              discovery call — no bloated retainers, no hidden fees.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <Pricing />
      <CTASection />
    </div>
  );
}
